<div style="height: 70vh; margin: 10px"
     leaflet
     [leafletLayers]="mapLayers"
     [leafletOptions]="options"
     (leafletClick)="onClickMap($event)"
     (leafletMapReady)="mapReady($event)">
</div>
<button (click)="gotoCurrentLocation()">Go to Current Location</button>
